<script lang="ts">
  interface Props {
    status: 'success' | 'error' | 'warning' | 'info' | 'pending';
    label: string;
    size?: 'sm' | 'md';
  }

  let { status, label, size = 'md' }: Props = $props();

  const styles: Record<string, string> = {
    success: 'bg-success/15 text-success border-success/30',
    error: 'bg-error/15 text-error border-error/30',
    warning: 'bg-warning/15 text-warning border-warning/30',
    info: 'bg-info/15 text-info border-info/30',
    pending: 'bg-text-muted/15 text-text-muted border-text-muted/30',
  };

  const dotColors: Record<string, string> = {
    success: 'bg-success',
    error: 'bg-error',
    warning: 'bg-warning',
    info: 'bg-info',
    pending: 'bg-text-muted',
  };
</script>

<span
  class="inline-flex items-center gap-1.5 rounded-full border font-medium
    {styles[status]}
    {size === 'sm' ? 'px-2 py-0.5 text-[10px]' : 'px-2.5 py-1 text-xs'}"
>
  <span class="rounded-full {dotColors[status]} {size === 'sm' ? 'w-1.5 h-1.5' : 'w-2 h-2'}"></span>
  {label}
</span>
